




































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import { Condition } from '@app/promotionHub/shared/types/Condition';
import { BonusKind } from '@core/models/bonus/Bonus';
import {
    translationBoldFormat,
    translationPlaceholderFormat,
} from '@superbet-group/web.lib.utilities';

export default defineComponent({
    name: 'PromotionDetailsBonusSection',
    props: {
        bonusTitle: {
            type: String,
            required: true,
        },
        bonusSubtitle: {
            type: String,
            required: false,
            default: null,
        },
        bonusConditions: {
            type: Array as PropType<string[] | Condition[]>,
            required: false,
            default: () => ([]),
        },
        kind: {
            type: String as PropType<BonusKind>,
            required: true,
        },
    },
    setup(props) {
        const { translate } = useI18n();

        function getBonusConditionValue(bonusCondition: Condition | string) {
            if (typeof bonusCondition === 'string') {
                return bonusCondition;
            } else if (props.kind === BonusKind.Betler) {
                return translationBoldFormat(translationPlaceholderFormat(translate(bonusCondition.label || ''), {
                    condition: translate(bonusCondition.value),
                    currency: bonusCondition.isCurrency ? translate('currencyAbbreviation') : '',
                }));
            } else {
                return `${translate(bonusCondition.label || '')} ${translate(bonusCondition.value)}`;
            }
        }

        return { getBonusConditionValue };
    },
    components: {
        SdsIcon,
    },
});
